import classNames from 'clsx';
import { format } from 'date-fns';
import React from 'react';

import StarsDatePicker from '@swf/components/Inputs/StarsDatePicker';
import Translation from '@swf/components/Translation/Translation';
import { equalOrAfterDate, required } from '@swf/core/utils/validators';

import useDisableField from '../../../../../../hooks/useDisableField';

import {
  TXTCLI_Invalid_date,
  TXTWCL_According_to_our_recordsX_the__ELL,
  TXTWCL_Expiry_date,
  TXTWCL_Please_enter_details_for_a_val_ELL
} from './ExpiryDateField.messages.json';
import { container, disable, expirySelect, label, wrapper } from './ExpiryDateField.scss';

export const expiryDateField = 'docExpiryDate';
const dateFormat = 'yyyy-LL-dd';

const ExpiryDateField: React.FC = () => {
  const disableField = useDisableField();

  return (
    <div className={wrapper}>
      <StarsDatePicker
        id={expiryDateField}
        label={<Translation {...TXTWCL_Expiry_date} />}
        validators={[
          required(TXTCLI_Invalid_date),
          equalOrAfterDate(format(new Date(), dateFormat), [
            TXTWCL_According_to_our_recordsX_the__ELL,
            TXTWCL_Please_enter_details_for_a_val_ELL
          ])
        ]}
        hideDateFormat
        className={classNames(expirySelect, {
          [disable]: disableField(expiryDateField)
        })}
        labelClassName={label}
        customContainerClassName={container}
      />
    </div>
  );
};

export default ExpiryDateField;
